<template>
    <BaseContainer class="dnnCloud-module-box" :loading="listLoading" :isHasPageFt="!listLoading">
      <template v-slot:hd>
        <!--工具条-->
        <el-col :span="24" class="toolbar">
          <el-form :inline="true" :model="souchs" @submit.native.prevent>
            <el-form-item>
              <el-input v-model="souchs.modelName" placeholder="模块名称" @keyup.enter.native="getModels(1)"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" size="medium" v-on:click="getModels(1)">查询</el-button>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" size="medium" @click="handleAdd" class="adds">新增</el-button>
            </el-form-item>
          </el-form>
        </el-col>
      </template>

      <template v-slot:main>
          <!--列表-->
          <el-table tooltip-effect="dark" :data="models" highlight-current-row v-loading="listLoading" style="width: 100%;" :height="maxTbHeight"
            @selection-change="selsChange" :header-cell-style="getRowClass" @sort-change="handleSortChange">
            <el-table-column type="index" :index="indexMethod" label="序号" width="100" >
              <template slot-scope="scope">
                  <span>{{(pageNumber - 1) * pageSize + scope.$index + 1}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="modulename" label="名称" min-width="220" sortable="custom" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="moduleid" label="模块ID" min-width="120" sortable="custom" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="intime" label="创建时间" min-width="180" sortable="custom" show-overflow-tooltip>
            </el-table-column>
            <el-table-column label="操作" min-width="220" style="text-algin:center">
              <template slot-scope="scope">
                 <span class="operate">
                    <el-tooltip effect="dark" content="编辑" placement="top" >
                      <span class="dnnfont iconEdit"  @click="handleEdit(scope.$index, scope.row)"></span>
                    </el-tooltip>

                    <el-tooltip effect="dark" content="删除" placement="top" v-if="!scope.row.delShow">
                        <span class="dnnfont icondelete"  @click="handleDel(scope.$index, scope.row)"></span>
                    </el-tooltip>
                    
                    <el-tooltip effect="dark" content="命令模块" placement="top" v-if="!scope.row.delShow">
                        <span class="dnnfont iconstatistics-all"  @click="handleList(scope.$index, scope.row)"></span>
                    </el-tooltip>
                 </span>

                <!-- <el-button type="primary" plain size="small" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
                <el-button type="danger" plain size="small" @click="handleDel(scope.$index, scope.row)">删除</el-button>
                <el-button type="success" plain size="small" @click="handleList(scope.$index, scope.row)">命令模块</el-button> -->
              </template>
            </el-table-column>
          </el-table>

          <!--新增界面-->
          <el-dialog class="model-edit" title="新增" :visible.sync="addFormVisible" :close-on-click-modal="false">
            <el-form :model="addForm" label-width="80px" :rules="addFormRules" ref="addForm">
              <el-row>
                <el-col :span="22"> 
                  <el-form-item label="名称" prop="modulename">
                    <el-input v-model="addForm.modulename" auto-complete="off"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="22"> 
                  <el-form-item label="模块ID" prop="moduleid">
                    <el-input  v-model="addForm.moduleid" @keyup.enter.native="addSubmit"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
            <div slot="footer" class="dialog-footer" style="text-align:center">
              <el-button @click.native="addFormVisible = false">取消</el-button>
              <el-button type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
            </div>
          </el-dialog>

        <!--编辑界面-->
        <el-dialog class="model-edit" title="编辑" :visible.sync="editFormVisible" :close-on-click-modal="false">
          <el-form :model="editForm" label-width="80px" :rules="editFormRules" ref="editForm">
            <el-row>
              <el-col :span="22"> 
                <el-form-item label="名称" prop="modulename">
                  <el-input v-model="editForm.modulename" auto-complete="off"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="22"> 
                <el-form-item label="模块ID" prop="moduleid">
                  <el-input v-model="editForm.moduleid" auto-complete="off" @keyup.enter.native="editSubmit"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <div slot="footer" class="dialog-footer" style="text-align:center">
            <el-button @click.native="editFormVisible = false">取消</el-button>
            <el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
          </div>
        </el-dialog>
      
        <!--命令界面-->
        <el-dialog class="model-edit" :title="modulenames" :visible.sync="editListVisible" :close-on-click-modal="false">
          <el-col :span="24" class="toolbar">
            <el-form :inline="true" @submit.native.prevent>
              <el-form-item>
                <el-input v-model="editListSouch.name" placeholder="名称" @keyup.enter.native="getZJ(1)"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" v-on:click="getZJ(1)">查询</el-button>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="editListAdd" class="adds">添加</el-button>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" :loading="importLoading" @click="$refs.clearFileModal.click()">导入</el-button>
              </el-form-item>
              <input
                type="file"
                id="importModule"
                style="display:none"
                name="file"
                ref="clearFileModal"
                @change="importModuleFile($event)"
              />
              <el-form-item>
                <el-button type="primary" @click="handleExportModule">导出</el-button>
              </el-form-item>
            </el-form>
          </el-col>
          <el-table tooltip-effect="dark" :data="editList" highlight-current-row  style="width: 100%;" >
            <el-table-column type="index"  label="序号" width="80">
            </el-table-column>
            <el-table-column prop="modulename" label="名称" min-width="200" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="moduleid" label="模块ID" min-width="120" >
            </el-table-column>
            <el-table-column prop="point" label="分数" min-width="120" >
            </el-table-column>
            <el-table-column label="操作" min-width="160" style="text-algin:center">
              <template slot-scope="scope">
                <el-button type="primary" plain size="small" @click="editListEdit(scope.$index, scope.row)">编辑</el-button>
                <el-button type="danger" plain size="small" @click="editListDel(scope.$index, scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-col :span="24" class="toolbar" style="margin-top:0;">
            <el-pagination layout="prev, pager, next" :current-page="pageNumber2" @current-change="handleCurrentChange2" 
              :page-size="10" :total="total2" style="float:right;">
            </el-pagination>
          </el-col>

          <div slot="footer" class="dialog-footer" style="text-align:center;">
            <el-button @click.native="editListVisible = false">关闭</el-button>
          </div>
        </el-dialog>


        <!--命令新增界面-->
        <el-dialog class="model-edit" title="命令新增" :visible.sync="addListVisible" :close-on-click-modal="false">
          <el-form :model="addListForm" label-width="80px"  ref="addListForm">
            <el-row>
              <el-col :span="22"> 
                <el-form-item label="名称" prop="modulename">
                  <el-input v-model="addListForm.modulename" auto-complete="off"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="22"> 
                <el-form-item label="模块ID" prop="moduleid">
                  <el-input v-model="addListForm.moduleid" auto-complete="off"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="22"> 
                <el-form-item label="分数" prop="point">
                  <el-input v-model="addListForm.point" auto-complete="off"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <div slot="footer" class="dialog-footer" style="text-align:center">
            <el-button @click.native="addListVisible = false">取消</el-button>
            <el-button type="primary" @click.native="addListSubmit" :loading="addListLoading">提交</el-button>
          </div>
        </el-dialog>

        <!--命令修改界面-->
        <el-dialog class="model-edit" title="命令修改" :visible.sync="editVisibleList" :close-on-click-modal="false">
          <el-form :model="editFormList" label-width="80px"  ref="editFormList">
            <el-row>
              <el-col :span="22"> 
                <el-form-item label="名称" prop="modulename">
                  <el-input v-model="editFormList.modulename" auto-complete="off"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="22"> 
                <el-form-item label="模块ID" prop="moduleid">
                  <el-input v-model="editFormList.moduleid" auto-complete="off"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="22"> 
                <el-form-item label="分数" prop="point">
                  <el-input v-model="editFormList.point" auto-complete="off"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <div slot="footer" class="dialog-footer" style="text-align:center">
            <el-button @click.native="editVisibleList = false">取消</el-button>
            <el-button type="primary" @click.native="editSubmitList" :loading="editLoadingList">提交</el-button>
          </div>
        </el-dialog>

      </template>

      <template v-slot:ft>
        <!--工具条-->
        <el-col :span="24">
          <el-pagination 
            layout="sizes, prev, pager, next"
            :page-sizes="[10, 20, 30, 50,100]"
            :current-page="pageNumber" 
            @current-change="handleCurrentChange" 
            @size-change="handleSizeChange"
            :page-size="pageSize"
            :total="total" 
            style="float:right;">
          </el-pagination>
        </el-col>
      </template>
    </BaseContainer>
</template>
<script>

import { API__code, API_Models } from '../../../api/index.js'
import BaseContainer from '@/components/BaseContainer'
import fitTableHeight from '@/mixins/fitTableHeight.js'
import $ from 'jquery'
export default {
  mixins: [fitTableHeight],
  data(){
    return {
      editFormList:{},
      editVisibleList:false,
      editLoadingList:false,
      editListSouch:{},

      addListVisible:false,
      addListForm:{},
      addListLoading:false,

      pageNumber2:1,
      pageSize2:10,
      total2:0,

      souchs:{
        modelName:'',
      },
      token:'',
      checkCode:'',
      id:'',
      listLoading:false,
      models:[],
      total:0,
      pageNumber:1,
      pageSize: 20,
      addForm:{
        moduleid:'',
        modulename:'',
      },
      addFormRules: {
        modulename: [
          { required: true, message: '请输入名称', trigger: 'blur' }
        ],
        moduleid: [
          { required: true, message: '请输入模块ID', trigger: 'blur' }
        ],
      },
      addFormVisible:false,
      addLoading:false,

      editForm:{
        moduleid:'',
        modulename:'',
      },
      editLoading:false,
      editFormRules: {
        modulename: [
          { required: true, message: '请输入名称', trigger: 'blur' }
        ],
        moduleid: [
          { required: true, message: '请输入模块ID', trigger: 'blur' }
        ],
      },
      editFormVisible:false,

      modulenames:'',
      moduleids:'',
      editList:[],
      editListVisible:false,
      editListLoading:false,
      orderType:'',
      orderStr:'',

      importLoading:false,
      exportModuleUrl:'',
    }
  },

  components: {
    BaseContainer
  },

  methods:{
    handleExportModule() {
      if (!this.exportModuleUrl) {
        this.$message.error('导出地址无效！');
        return;
      }
      const now = new Date();
      const y = now.getFullYear();
      const m = String(now.getMonth() + 1).padStart(2, '0');
      const d = String(now.getDate()).padStart(2, '0');
      const fileName = (this.modulenames || '模块命令') + y + m + d + '.xlsx';

      const a = document.createElement("a");
      fetch(this.exportModuleUrl)
        .then((res) => res.blob())
        .then((blob) => {
          a.href = URL.createObjectURL(blob);
          a.download = fileName;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          URL.revokeObjectURL(a.href);
        })
        .catch(() => {
          this.$message.error('导出失败！');
        });
    },
    importModuleFile(filex) {
      var file = filex.target.files[0];
      console.log('file',file);
      var formData = new FormData();
      formData.append('file',file);
      
      var that = this;
      if(!file){
        that.$message.error('请选择文件！');
        return;
      }
      that.importLoading = true;
      $.ajax({
        url: API_Models.importAdminModule() + "?token=" + this.token + "&checkCode=" + this.checkCode + "&parentid=" + this.moduleids,
        type: "post",
        data: formData,
        processData: false,
        contentType: false,
        dataType: "json",
        timeout: 180000,
        success: function(res) {
          if(res.code==200){
            that.$message.success(res.message);
          }else{
            that.$message.error(res.message);
          }
          that.importLoading = false;
          that.$refs.clearFileModal.value = '';
          that.getZJ(1);
        },
        error: function(err) {
          that.$message.error(res.message);
          that.importLoading = false;
          that.$refs.clearFileModal.value = '';
        }
      });
        
    },
    editSubmit:function(){
      if(!this.editForm.modulename && this.editForm.modulename != 0){
        this.$message.error('名称不可为空！');
        return;
      };
      if(!this.editForm.moduleid && this.editForm.moduleid != 0){
        this.$message.error('模块ID不可为空！');
        return;
      };
      let param = {
        id:this.editForm.id,
        token:this.token,
        checkCode:this.checkCode,
        mode:'update',
        moduleid: this.editForm.moduleid,
        modulename : this.editForm.modulename,
      }
      this.editLoading = true;
      API_Models.setAdminModule(param)
      .then((res) =>{
        if(res.data.code == API__code.SUCCESS){
          this.$message({
            message: '新增成功',
            type: 'success',
            center:true
          });
          
          this.editFormVisible = false;
          this.getModels();
        }else{
          this.$message.error(res.data.message);
          if(res.data.code == 403){
            this.$router.push({path: 'loginAdmin'});
          }
        }
        this.editLoading = false;
      }).catch(err =>{
        this.$message.error('数据丢失，试试重新登陆！');
        this.editLoading = false;
      });
    },
    addSubmit:function(){
      if(!this.addForm.modulename && this.addForm.modulename != 0){
        this.$message.error('名称不可为空！');
        return;
      };
      if(!this.addForm.moduleid && this.addForm.moduleid != 0){
        this.$message.error('模块ID不可为空！');
        return;
      };
      let param = {
        // id:this.id,
        token:this.token,
        checkCode:this.checkCode,
        mode:'save',
        moduleid: this.addForm.moduleid,
        modulename : this.addForm.modulename,
      }
      this.addLoading = true;
      API_Models.setAdminModule(param)
      .then((res) =>{
        if(res.data.code == API__code.SUCCESS){
          this.$message({
            message: '新增成功',
            type: 'success',
            center:true
          });
          
          this.addFormVisible = false;
          this.getModels();
        }else{
          this.$message.error(res.data.message);
          if(res.data.code == 403){
            this.$router.push({path: 'loginAdmin'});
          }
        }
        this.addLoading = false;
      }).catch(err =>{
        this.$message.error('数据丢失，试试重新登陆！');
        this.addLoading = false;
      });
    },
    //显示新增界面
    handleAdd: function () {
      this.addFormVisible = true;
      this.addForm = {
        name: '',
        modelID:'',
      };
    },
    indexMethod(index) {
      return (index+1)+(this.pageNumber-1)*pageSize;
    },
    getRowClass({ row, column, rowIndex, columnIndex }) {
        if (rowIndex == 0) {
            return "background:#F5F7FA";
        } else {
            return "";
        }
    },
    selsChange: function (sels) {
      this.sels = sels;
    },
    handleSizeChange(val) {
			this.pageSize = val;
			this.getModels();
		},
    handleCurrentChange(val) {
      this.pageNumber = val;
      this.getModels();
    },
    handleCurrentChange2(val) {
      this.pageNumber2 = val;
      this.getZJ();
    },
    handleSortChange:function(val){
      if(val){
        if(val.prop == "modulename"){
          this.orderStr = "modulenameOrder";
        }else if(val.prop == "moduleid"){
          this.orderStr = "moduleidOrder";
        }else if(val.prop == "intime"){
          this.orderStr = "intimeOrder";
        }
        if(val.order == "descending"){
          this.orderType = "desc";
        }else{
          this.orderType = "asc";
        }
      }
      this.getModels();
    },
    getModels:function(val){
      if(val == 1){
        this.pageNumber = 1;
      }
      let param = {
        // id:this.id,
        token:this.token,
        checkCode:this.checkCode,
        searchModuleName:this.souchs.modelName,
        listType:'page',
        pageNumber:this.pageNumber,
        pageSize:this.pageSize,

        orderStr:this.orderStr,
        orderType:this.orderType,
      }
      this.listLoading = true;
      API_Models.getAdminModule(param)
      .then((res) =>{
        if(res.data.code == API__code.SUCCESS){
          // debugger;
          if(res.data.data){
            this.total = res.data.data.totalRow;
            this.models = res.data.data.list;
          }
          // this.models = (res.data.data).slice((this.pageNumber-1)*this.pageSize,this.pageNumber*this.pageSize);
          
        }else{
          this.$message.error(res.data.message);
          if(res.data.code == 403){
            this.$router.push({path: 'loginAdmin'});
          }
        }
        this.listLoading = false;
      }).catch(err =>{
        this.$message.error('数据丢失，试试重新登陆！');
        this.listLoading = false;
      });
    },
    //删除
    handleDel: function (index, row) {
      this.$confirm('确认删除该模块吗?', '提示', {
        type: 'warning'
      }).then(() => {
        let para = { 
          id: row.id,
          token: this.token,
          checkCode: this.checkCode,
        };
        API_Models.delAdminModule(para).then((res) => {
          if(res.data.code == API__code.SUCCESS){
            this.$message({
              message: '删除成功',
              type: 'success'
            });
            this.getModels();
          }else{
            this.$message.error(res.data.message);
            if(res.data.code == 403){
              this.$router.push({path: 'loginAdmin'});
            }
          }
        }).catch((err ) => {
          this.$message.error('数据丢失，试试重新登陆！');
        });
      });
    },
    //子集
    handleList:function (index, row) {
        this.editListVisible = true;
        this.modulenames = row.modulename;
        this.moduleids = row.moduleid

        // 模块导出文件地址
        this.exportModuleUrl = API_Models.exportAdminModule() + "?token=" + this.token + "&checkCode=" + this.checkCode + "&parentid=" + this.moduleids
        
        this.getZJ();
    },
    getZJ:function(val){
      if(val == 1){
        this.pageNumber2 = 1;
      }
      let param = {
          token:this.token,
          checkCode:this.checkCode,
          parentid:this.moduleids,
          searchStr:this.editListSouch.name,
          listType:'page',
          pageNumber:this.pageNumber2,
          pageSize:this.pageSize2,
        }
        API_Models.getAdminModuleTwo(param)
        .then((res) =>{
          if(res.data.code == API__code.SUCCESS){
            this.total2 = res.data.data.totalRow;
            this.editList = res.data.data.list;
          }
        }).catch(err =>{
          this.$message.error('数据丢失，试试重新登陆！');
        });
    },
    editListDel:function (index, row) {
      this.$confirm('确认删除该模块吗?', '提示', {
        type: 'warning'
      }).then(() => {
        let param ={
          token:this.token,
          checkCode:this.checkCode,
          id:row.id,
          parentid:this.moduleids,
          moduleid:row.moduleid,
        }
        API_Models.delAdminModule(param)
        .then((res) =>{
          if(res.data.code == API__code.SUCCESS){
            this.$message({
              message: '删除成功',
              type: 'success'
            });
            this.getZJ();
          }
        }).catch(err =>{
          this.$message.error('数据丢失，试试重新登陆！');
        });
      })
    },
    //命令修改提交
    editSubmitList:function(){
      if(!this.editFormList.modulename && this.editFormList.modulename != 0){
        this.$message.error('名称不可为空！');
        return;
      }
      if(!this.editFormList.moduleid && this.editFormList.moduleid != 0){
        this.$message.error('模块ID不可为空！');
        return;
      }
      let param = {
        token:this.token,
        checkCode:this.checkCode,
        // parentid:this.moduleids,
        id:this.editFormList.id,
        moduleid:this.editFormList.moduleid,
        modulename:this.editFormList.modulename,
        mode:'',
        point:this.editFormList.point,
      }
      this.editLoadingList = true;
      API_Models.setAdminModule(param)
      .then((res) =>{
        if(res.data.code == API__code.SUCCESS){
          this.$message({
              message: '修改成功',
              type: 'success'
            });
            this.getZJ();
        }else{
          this.$message.error(res.data.message);
          if(res.data.code == 403){
            this.$router.push({path: 'loginAdmin'});
          }
        }
        this.editLoadingList = false;
        this.editVisibleList = false;
      }).catch(err =>{
        this.editLoadingList = false;
        this.$message.error('数据丢失，试试重新登陆！');
      })
    },
    
    editListEdit:function(index,row){
      this.editVisibleList = true;
      this.editFormList = Object.assign({}, row);
    },
    editListAdd:function(){
      this.addListVisible = true;
    },
    addListSubmit:function(){
      if(!this.addListForm.modulename){
        this.$message.error('名称不可为空！');
        return;
      }
      if(!this.addListForm.moduleid){
        this.$message.error('模块ID不可为空！');
        return;
      }
      let param = {
        token:this.token,
        checkCode:this.checkCode,
        parentid:this.moduleids,
        moduleid:this.addListForm.moduleid,
        modulename:this.addListForm.modulename,
        mode:'save',
        point:this.addListForm.point,
      }
      this.addListLoading = true;
      API_Models.setAdminModule(param)
      .then((res) =>{
        if(res.data.code == API__code.SUCCESS){
          this.$message({
              message: '添加成功',
              type: 'success'
            });
            this.getZJ();
        }else{
          this.$message.error(res.data.message);
          if(res.data.code == 403){
            this.$router.push({path: 'loginAdmin'});
          }
        }
        this.addListLoading = false;
        this.addListVisible = false;
      }).catch(err =>{
        this.addListLoading = false;
        this.$message.error('数据丢失，试试重新登陆！');
      })
    },
    handleEdit:function (index, row) {
        this.editFormVisible = true;
				this.editForm = Object.assign({}, row);
		},
    //读取cookie
    getCookie: function() {
      if (document.cookie.length > 0) {
          var arr = document.cookie.split('; '); //这里显示的格式需要切割一下自己可输出看下
          for (var i = 0; i < arr.length; i++) {
              var arr2 = arr[i].split('='); //再次切割
              //判断查找相对应的值
              if (arr2[0] == 'dnnyptadmin_token') {
                  this.token = arr2[1]; //保存到保存数据的地方
              } else if (arr2[0] == 'dnnyptadmin_checkCode') {
                  this.checkCode = arr2[1];
              } else if (arr2[0] == 'dnnyptadmin_id') {
                  this.id = arr2[1];
              }
          }
      }
    }
    
  },
  created(){
    this.getCookie();
  },
  mounted(){
    this.getModels();
  }
}
</script>

<style lang="scss">
.dnnCloud-module-box {
  .base-container-bd {
    .content-hd {
      .el-form-item {
        margin-bottom: 0;
      }
    }
  }
}

</style>
<style scoped>

</style>



// WEBPACK FOOTER //
// Module.vue?5a3f867e